import { createComponentStore } from '../../utils/createComponentStore';

const keyAuto = () => {
  return 'table_trigger_' + (Math.floor(Math.random() * 90000000) + 10000).toString();
};

const initData = () => ({
  outputKey: keyAuto(),
  tableId: '',
  eventTypes: ['INSERT', 'UPDATE', 'DELETE'],
  columnFilters: [],
});

const onLoadData = (data) => ({
  outputKey: data?.outputKey || keyAuto(),
  tableId: data?.tableId || '',
  eventTypes: data?.eventTypes || ['INSERT', 'UPDATE', 'DELETE'],
  columnFilters: data?.columnFilters || [],
});

const { getStore: getTriggerTableV2Store, defaultStore } = createComponentStore({
  type: 'trigger_table_v2',
  endpoint: 'trigger_table_v2',
  registryKey: 'trigger_table_v2',
  initData,
  onLoadData,
});

export { getTriggerTableV2Store, defaultStore };
export default defaultStore;
